import * as React from "react";
import C from "classnames";
export const NavBar = (props) => {
    return (React.createElement("ul", { className: C("navbar-nav", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=NavBar.js.map